import React from 'react';
import NotFound from '~/components/NotFound';
import Header from '~/components/Header';

export default () => (
  <div className='404' style={{height: 'calc(100% - 50px)'}}>
    <Header />
    <NotFound />
  </div>
);
